import { PCheckbox } from '@porsche-design-system/components-react';
import React, { memo } from 'react';

export const VersionFilterPanel = memo(
  ({ versions, selectedVersions, toggleVersions, isOpen, toggleMenu }) => {
    const unassignedVersion = 'Unassigned';

    return (
      <div
        className="fixed bottom-0 left-0 p-4 m-4 shadow-lg rounded-lg w-60"
        style={{
          /* todo: use general class */
          backdropFilter: 'blur(10px)',
          backgroundColor: 'rgba(255, 255, 255, 0.5)',
        }}
      >
        <div className="w-full">
          <div className="flex justify-between items-center mb-2">
            <span className="text-md font-bold">Versions</span>
            <button
              type="button"
              aria-expanded={isOpen}
              onClick={toggleMenu}
              className="text-sm p-1 rounded-full transition hover:bg-gray-200"
              style={{
                backdropFilter: 'blur(5px)',
                backgroundColor: 'rgba(255, 255, 255, 0.4)',
              }}
            >
              <span
                className={`arrow inline-block transition-transform duration-300 ${
                  isOpen ? 'rotate-180' : 'rotate-0'
                }`}
              >
                ⇵
              </span>
            </button>
          </div>

          {isOpen && (
            <div className="flex flex-col gap-1">
              <PCheckbox
                label={unassignedVersion}
                hideLabel={false}
                name="version-unassigned"
                compact="true"
                checked={selectedVersions[unassignedVersion]}
                onClick={() => toggleVersions(unassignedVersion)}
              />

              {versions.map((version) => (
                <PCheckbox
                  key={version}
                  label={version}
                  hideLabel={false}
                  name={`version-${version}`}
                  compact="true"
                  checked={selectedVersions[version]}
                  onClick={() => toggleVersions(version)}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }
);
